var map = {
	"./CustomMetadataEntry.schema.json": "04027",
	"./CustomMetadataTreeEntry.schema.json": "20ab",
	"./DocumentRevisionInfo.schema.json": "2cc2",
	"./FirestoreGeoPoint.schema.json": "208c",
	"./FirestoreTimestamp.schema.json": "37fb",
	"./I18nInline.schema.json": "0db5",
	"./I18nKey.schema.json": "1ea2",
	"./MultilingualText.schema.json": "9655",
	"./NamedRef.schema.json": "7f44",
	"./NonEmptyString.schema.json": "e121",
	"./OptionalObject.schema.json": "34f0",
	"./OptionalUserRef.schema.json": "0ec8",
	"./UserId.schema.json": "7483",
	"./UserRef.schema.json": "2351",
	"./VdaMatrixData.schema.json": "776b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f10a";